import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  NgModule,
  NgZone,
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { AppType, CheckoutType } from "src/app/shared/helpers/helper.common";
import { Address, Merchant } from "src/app/shared/models/merchant";
import { OrderService } from "src/app/shared/services/order.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { filter } from "rxjs/operators";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { NgStyle, AsyncPipe, DecimalPipe } from "@angular/common";
import { UserService } from "src/app/shared/services/user.service";
import { CoreService } from "src/app/shared/services/core.service";
import { Fulfillmentmodel } from "src/app/shared/pageModels/CommonPay";
import { add } from "cypress/types/lodash";
import { merge } from "lodash";
@Component({
  selector: "app-select-location",
  templateUrl: "./select-location.component.html",
  styleUrls: ["../../pay/pay/pay.component.scss"],
  standalone: true,
  imports: [NgStyle, FormsModule, NgSelectModule, AsyncPipe, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class selectLocationComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @ViewChild("DeliveryFeeInfo", { static: false }) private DeliveryFeeInfo;
  @ViewChild("ValidationModal", { static: false }) private ValidationModal;
  @ViewChild("checkoutModal", { static: false }) private CheckoutModal;
  @ViewChild("ProcessingFeeInfo", { static: false })
  private ProcessingFeeInfo;
  @ViewChild("AddressValidationModal", { static: false })
  private AddressValidationModal;
  @Input() Addresses: Address[];
  @Input() isDelivery: boolean;
  @Input() isServe: boolean;
  @Input() isServeItFees: boolean;
  @Input() fulfillmentModel: Fulfillmentmodel;
  @Input() selectedTable: any;
  @Input() selectedAddress: any;
  @Input() isSelectedLocation: boolean;

  @Input() Merchant: Merchant;
  @Output() ok = new EventEmitter<Object>();
  @Output() popupClose = new EventEmitter();
  @Output() OpenAddress = new EventEmitter<Address>();
  @Output() openLogin = new EventEmitter<Object>();

  Merchant$ = this.coreService.Merchant$;
  currentBasket = this.coreService.currentBasket;
  IsError;
  IsAddressNotAvailable;
  Message;
  ValidationMessage;
  AddressValidationMessage;
  PopupHeader;
  IsAddressVisible;
  IsDeliveryFeeApply;
  DeliveryFeeProduct = [];

  FeeMessage;
  processingFeeAmount = 0;
  processingFeePercentage = 0;
  feeText = "";
  isProcessingFee = false;
  isProcessingFeePopup = false;
  totalProcessingFee = 0;
  currentMerchant;
  popupText;
  isPopupVisible;
  ShowLoginOption;
  enable_location_selection_screen;

  constructor(
    private coreService: CoreService,
    private orderService: OrderService,
    private userService: UserService,
    private modalService: NgbModal,
    private ngZone: NgZone,
    private cds: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.fulfillmentModel = new Fulfillmentmodel();

    this.Merchant$?.subscribe((data) => {

      if (!data) return;
      this.currentMerchant = data;

      const settings = this.currentMerchant?.webapp_settings;

      this.enable_location_selection_screen =
        settings?.enable_location_selection_screen ?? false;

      this.fulfillmentModel.apptype = settings?.is_scan_webapp ?? null;

      switch (settings?.is_scan_webapp) {
        case AppType.Book_Order_Online_App:
          this.fulfillmentModel.orderType = CheckoutType.Book;
          break;
        case AppType.Scan_in_store_App:
          this.fulfillmentModel.orderType = CheckoutType.Take;
          break;
        case AppType.restaurant_App:
          this.fulfillmentModel.orderType = CheckoutType.Serve;
          break;
        case AppType.Order_Online_App:
          this.fulfillmentModel.orderType = settings?.is_collect
            ? CheckoutType.Collect
            : CheckoutType.Deliver;
          break;
        case AppType.Scan_Promotion_App:
          this.fulfillmentModel.orderType = settings?.is_collect
            ? CheckoutType.Collect
            : CheckoutType.Deliver;
          break;
        default:
          break;
      }

      // Tables
      this.fulfillmentModel.tableOptions = (
        this.currentMerchant?.table ?? []
      ).map((element) => ({
        id: element?.id ?? 0,
        name: element?.description ?? "",
      }));

      // Waiters
      this.fulfillmentModel.waiterOptions = (
        this.currentMerchant?.waiter ?? []
      ).map((element) => ({
        id: element?.id ?? 0,
        name: element?.name ?? "",
      }));

      // Assign tables
      this.fulfillmentModel.assignTableOptions = (
        this.currentMerchant?.assign_table ?? []
      ).map((element) => ({
        id: element?.id ?? 0,
        name: element?.description ?? "",
      }));

      // Rooms
      this.fulfillmentModel.roomOptions = (
        this.currentMerchant?.room ?? []
      ).map((element) => ({
        id: element?.id ?? 0,
        name: element?.description ?? "",
      }));

      // Online / Book / Promotion Apps
      if (
        settings?.is_scan_webapp === AppType.Order_Online_App ||
        settings?.is_scan_webapp === AppType.Book_Order_Online_App ||
        settings?.is_scan_webapp === AppType.Scan_Promotion_App
      ) {
        if (settings?.is_scan_webapp === AppType.Book_Order_Online_App) {
          this.isDelivery = true;
        }

        if (this.IsUserAuthunticated()) {
          this.userService?.GetUserProfile()?.subscribe((response) => {
            this.Addresses = response?.addresses ?? [];
          });
        }
      }

      // Restaurant App
      if (settings?.is_scan_webapp === AppType.restaurant_App) {
        if (this.IsUserAuthunticated()) {
          this.userService?.GetUserProfile()?.subscribe((response) => {
            this.Addresses = response?.addresses ?? [];
          });
        }

        let message = "Select your location or fulfillment method";

        if (
          settings?.enable_serve_webapp_location_service &&
          settings?.is_user_browser_location_on
        ) {
          message +=
            " We will be sending your current device pin location to the merchant along with your order details. Please press OK if you wish to proceed and place the order or Cancel if you wish to abandon.";
        }

        if (this.fulfillmentModel) {
          this.fulfillmentModel.dynamicTextMessage = message.trim();
        }
      }

      // Delivery / Serve flags
      if (this.fulfillmentModel?.orderType === CheckoutType.Deliver) {
        this.isDelivery = true;
      } else if (this.fulfillmentModel?.orderType === CheckoutType.Serve) {
        this.isServe = true;
      } else {
        this.isDelivery = false;
        this.isServe = false;
      }

      this.CheckForLocations?.();

      this.isServeItFees = this.currentMerchant?.serveit_fee_apply === 1;

      if ((this.Addresses?.length ?? 0) === 1) {
        this.fulfillmentModel.selectedaddress = this.Addresses[0];
      }

      this.cds?.detectChanges();
    });

    this.coreService?.basket$?.subscribe((data) => {
      this.currentBasket = data ?? null;
    });
  }


  // Lifecycle hook: ngAfterViewInit
  ngAfterViewInit() {}
  // async AlertBox(message) {
  //   this.ngZone.run(() => {
  //     this.OpenMessage.Openpopup(message);
  //   });
  // }

  ngOnChanges(changes: SimpleChanges): void {
    // Safely handle fulfillmentModel & orderType
    if (this.fulfillmentModel?.orderType != null) {
      if (this.fulfillmentModel.orderType === CheckoutType.Deliver) {
        this.isDelivery = true;
        this.isServe = false;
      } else if (this.fulfillmentModel.orderType === CheckoutType.Serve) {
        this.isServe = true;
        this.isDelivery = false;
      } else {
        this.isDelivery = false;
        this.isServe = false;
      }
    } else {
      this.isDelivery = false;
      this.isServe = false;
    }

    // Safely call method
    if (typeof this.CheckForLocations === "function") {
      this.CheckForLocations();
    }

    // Null-safe Merchant check
    this.isServeItFees = this.Merchant?.serveit_fee_apply === 1;

    // Null-safe Addresses handling
    if (Array.isArray(this.Addresses) && this.Addresses.length === 1) {
      if (this.fulfillmentModel) {
        this.fulfillmentModel.selectedaddress = this.Addresses[0];
      }
    }

    // Assign selectedTable and selectedAddress only if model exists
    if (this.fulfillmentModel) {
      this.fulfillmentModel.selectedTable = this.selectedTable ?? null;
      this.fulfillmentModel.selectedaddress = this.selectedAddress ?? null;
    }

    // Null-safe method call
    if (typeof this.LocationChanged === "function") {
      if (this.Addresses == undefined || this.Addresses?.length === 0) {
        if (this.IsUserAuthunticated()) {
          this.userService.GetUserProfile().subscribe((response) => {
            this.Addresses = response.addresses;
          });
        }
      }
      setTimeout(() => {
        this.LocationChanged(this.selectedTable ?? null, true);
      }, 200);
    }

    /*
    // Payment option changes - keep commented but make null safe
    if (
      changes["paymentOptionSelected"]?.currentValue === true &&
      this.enable_location_selection_screen
    ) {
      const rawLocation = localStorage.getItem("selected_location");
      console.log(rawLocation);
  
      if (rawLocation) {
        try {
          const selectedLocation = JSON.parse(rawLocation) as Fulfillmentmodel;
          const specialInstructions = selectedLocation?.specialInstructions;
  
          if (selectedLocation && this.fulfillmentModel) {
            this.fulfillmentModel = merge({}, selectedLocation, this.fulfillmentModel);
            this.fulfillmentModel.specialInstructions = specialInstructions ?? null;
  
            if (typeof this.LocationChanged === 'function') {
              this.LocationChanged(this.fulfillmentModel.selectedTable ?? null, true);
            }
          }
        } catch (error) {
          console.error("Error parsing selected_location:", error);
        }
      }
    }
    */
  }

  OpenMap() {
    this.OpenAddress.emit(null);
  }

  LocationSelectedClick(fulfillment: Fulfillmentmodel) {
    localStorage.setItem("selected_location", JSON.stringify(fulfillment));
    if (
      this.currentMerchant?.webapp_settings?.enable_location_selection_screen
    ) {
      var Request = {};
      if (
        fulfillment.selectedTable.name == "DLVR" ||
        fulfillment.selectedTable.name == "HDLVR"
      ) {
        Request = {
          table_id: fulfillment.selectedTable.id,
          is_user_location: true,
          address_id: fulfillment.selectedaddress.id,
        };
      } else {
        Request = {
          table_id: fulfillment.selectedTable.id,
          is_user_location: false,
          address_id: fulfillment.selectedaddress.id,
        };
      }

      this.userService.SetSelectedLocation(Request).subscribe((resp) => {
        if (resp.data) {
          console.log(resp.data);
          // this.modalService.open(this.locationinfo, {
          //   centered: true,
          //   scrollable: true,
          // });
        }
      });
    }
    this.ok.emit(fulfillment);
    this.close();
  }

  PlaceOrder(fulfillment: Fulfillmentmodel) {
    this.close();

    if (this.isProcessingFee) {
      this.calculateProcessingFee();
      if (this.isPopupVisible) {
        this.applyProcessingFees();
      } else {
        this.agreeProcessingFee();
      }
    } else {
      this.confirmOrder();
    }
  }

  confirmOrder() {
    // Get the discount percentage from the promocode data
    let strPromocodeDiscount: string =
      this.currentBasket?.promocode?.data?.discount;
    let promocodeDiscount: number = Number(strPromocodeDiscount);

    // Calculate the total saving by applying the promocode discount percentage
    let totalSaving: number =
      (promocodeDiscount *
        (this.currentBasket.discountableTotal -
          (this.fulfillmentModel.deliveryFees ?? 0))) /
      100;

    if (totalSaving > 0) {
      this.currentBasket.isPromo = true;
      this.currentBasket.promoDiscount = totalSaving;
    }

    const avgVat =
      this.currentBasket.items
        .filter((x) => x.price > 0)
        .reduce((sum, item) => sum + item.vat_rate, 0) /
      this.currentBasket.items.filter((x) => x.price > 0).length;

    if (this.fulfillmentModel.isTip) {
      this.currentBasket.VATAmt =
        ((this.currentBasket.totalPayableAmount -
          this.fulfillmentModel.tipAmount +
          (this.currentBasket.processingFee ?? 0)) *
          avgVat) /
        100;
    } else {
      this.currentBasket.VATAmt =
        ((this.currentBasket.totalPayableAmount +
          (this.currentBasket.processingFee ?? 0)) *
          avgVat) /
        100;
    }

    this.modalService.open(this.CheckoutModal, {
      centered: true,
      scrollable: true,
      backdrop: "static",
    });
  }

  order(fulfillment: Fulfillmentmodel) {
    if (this.fulfillmentModel.selectedTable) {
      if (this.IsAddressVisible) {
        if (this.fulfillmentModel.selectedaddress) {
          this.ok.emit(fulfillment);
        } else {
          this.ValidationMessage = "Please select an address";
          this.modalService.open(this.ValidationModal, {
            centered: true,
            scrollable: true,
            backdrop: "static",
          });
        }
      } else {
        this.ok.emit(fulfillment);
      }
    } else {
      this.ValidationMessage = "Please select fulfillment option";
      this.modalService.open(this.ValidationModal, {
        centered: true,
        scrollable: true,
        backdrop: "static",
      });
    }
  }

  calculateProcessingFee() {
    if (this.currentMerchant.fixed_processing_fees_type === 0) {
      this.processingFeeAmount = Number(
        this.currentMerchant.processing_fees_amount
      );
    } else if (this.currentMerchant.fixed_processing_fees_type === 1) {
      const totalPayableAmount = this.currentBasket.totalPayableAmount;

      const feeTier = this.currentMerchant.tier_base_processing_fees.find(
        (tier: any) =>
          totalPayableAmount >= Number(tier.min_range) &&
          totalPayableAmount < Number(tier.max_range)
      );

      if (feeTier) {
        this.processingFeeAmount = Number(feeTier.fixed_amount);
      }
    }

    this.totalProcessingFee = Number(
      (
        Number(this.processingFeeAmount) +
        Number(
          (this.currentBasket.totalPayableAmount *
            this.processingFeePercentage) /
            100
        )
      ).toFixed(this.currentMerchant.currency_decimals ?? 2)
    );
  }

  applyProcessingFees() {
    this.Message = this.popupText;
    // "To ensure the continued development and maintenance of our app, a processing service fee of " +
    // this.currentMerchant.currency +
    // " " +
    // this.totalProcessingFee +
    // " will be applied to your order.<br>The fee helps us to continue to provide you with a seamless ordering experience and exclusive features.<br>Your total will be " +
    // this.currentMerchant.currency +
    // " " +
    // Number(this.currentBasket.totalPayableAmount + this.totalProcessingFee) +
    // " do you wish to continue?";

    this.modalService.open(this.ProcessingFeeInfo, {
      centered: true,
      scrollable: true,
      backdrop: "static",
    });
  }

  agreeProcessingFee() {
    this.currentBasket.isProcessingFee = true;
    this.currentBasket.processingFee = this.totalProcessingFee;
    this.currentBasket.feeText = this.feeText;

    this.confirmOrder();
  }

  close() {
    this.fulfillmentModel.selectedTable = null;
    this.fulfillmentModel.selectedaddress = null;
    this.IsAddressVisible = false;
    this.popupClose.emit();
  }

  CheckForAddress(): boolean {
    if (this.fulfillmentModel.selectedTable) {
      if (this.IsAddressVisible) {
        if (this.fulfillmentModel.selectedaddress) {
          return true;
        } else {
          this.ValidationMessage = "Please select an address";
          this.modalService.open(this.ValidationModal, {
            centered: true,
            scrollable: true,
            backdrop: "static",
          });
          return false;
        }
      } else {
        return true;
      }
    } else {
      this.ValidationMessage = "Please select fulfillment option";
      this.modalService.open(this.ValidationModal, {
        centered: true,
        scrollable: true,
        backdrop: "static",
      });
      return false;
    }
    return true;
  }

  valueChanges(event) {
    this.fulfillmentModel.orderType = event.currentTarget.value;
    if (this.fulfillmentModel.orderType == CheckoutType.Deliver) {
      this.isDelivery = true;
      this.isServe = false;
    } else if (this.fulfillmentModel.orderType == CheckoutType.Serve) {
      this.isServe = true;
      this.isDelivery = false;
    } else {
      this.isDelivery = false;
      this.isServe = false;
    }

    if (this.Merchant.serveit_fee_apply == 1) {
      this.isServeItFees = true;
    } else {
      this.isServeItFees = false;
    }
  }
  Ok(fulfillment: Fulfillmentmodel) {
    if (this.fulfillmentModel.selectedTable) {
      if (this.DeliveryFeeProduct) {
        var deliveryFee;
        this.coreService.removeDeliveryFeeItemToBasket();
        this.DeliveryFeeProduct.forEach((elem) => {
          var bi = {
            Id: elem.id,
            qtyId: elem.id.toString(),
            productcatId: elem.catId,
            productId: null,
            name: elem.name,
            price: elem.is_discount ? elem.discounted_price : elem.price,
            discountprice: elem.is_discount ? elem.discounted_price : 0,
            is_discount: elem.is_discount,
            Actualprice: elem.price,
            productImage: elem.images[0]?.url,
            stockunlimited: elem.stock_unlimited,
            stock: elem.stock,
            extra_product_limit: elem.extra_product_limit ?? 0,
            quantity: 1,
            selFirstAttrName: "attr1",
            selSecondAttrName: "attr2",
            selFirstAttrValue: "",
            selSecondAttrValue: "",
            selectedVariantid: 0,
            SelectedVariantName: "",
            totalprice: this.coreService.GetTotalprice(elem),
            is_delivery_fee_product: elem.is_delivery_fee_product,
            vat_rate: elem.vat_rate,
            vat_amount: elem.vat_amount,
            is_mixandmatch: 0,
            is_promo_exclude: 0,
          };

          deliveryFee = this.coreService.GetTotalprice(elem);
          this.coreService.addDeliveryFeeItemToBasket(bi);
        });

        this.fulfillmentModel.deliveryFees = deliveryFee;

        this.modalService.dismissAll();

        setTimeout(() => {
          this.PlaceOrder(fulfillment);
        }, 500);
      }
    }
  }
  applyDeliveryFee(fulfillment: Fulfillmentmodel) {
    if (this.CheckForAddress()) {
      if (this.isServeItFees) {
        if (this.IsDeliveryFeeApply && !this.IsAddressVisible) {
          this.fulfillmentModel.selectedaddress = this.currentMerchant?.address;
        }
      }

      var param = "";
      if (fulfillment?.selectedaddress?.country == "United Kingdom")
        param = "postcode=" + fulfillment.selectedaddress.postcode;
      else param = "district_id=" + fulfillment?.selectedaddress?.district_id;

      this.orderService.getDeliveryfee(param).subscribe({
        next: (resp) => {
          var merchantCurrency = this.Merchant.currency ?? "AED";
          if (
            this.Merchant.webapp_settings?.is_scan_webapp ==
            AppType.Order_Online_App
          ) {
            if (resp.data.length > 0 && this.Merchant.delivery_fee_apply) {
              this.IsError = false;
              this.DeliveryFeeProduct = resp.data;
              var deliveryFeeAmount = this.DeliveryFeeProduct.reduce(
                (sum, item) => sum + item.price * 1,
                0
              );
              this.PopupHeader = "Delivery fees";
              this.Message =
                "Delivery fees of " +
                merchantCurrency +
                " " +
                Number(deliveryFeeAmount).toFixed(this.currentMerchant.currency_decimals ?? 2) +
                " will be added to your bill. Your total will be " +
                merchantCurrency +
                " " +
                Number(
                  this.currentBasket.totalPayableAmount + deliveryFeeAmount
                ).toFixed(this.currentMerchant.currency_decimals ?? 2) +
                " - do you wish to continue?";
              this.modalService.open(this.DeliveryFeeInfo, {
                centered: true,
                scrollable: true,
                backdrop: "static",
              });
            } else if (
              resp.data.length == 0 &&
              this.Merchant.delivery_fee_apply
            ) {
              this.IsError = true;
              this.PopupHeader = "Delivery fees";
              this.Message =
                "Please select an address inside our delivery area - check the Deliver It policy for further details (go to homepage and click about button)";
              this.fulfillmentModel.selectedaddress = undefined;
              this.modalService.open(this.DeliveryFeeInfo, {
                centered: true,
                scrollable: true,
                backdrop: "static",
              });
            } else {
              this.PlaceOrder(fulfillment);
            }
          } else if (
            this.Merchant.webapp_settings?.is_scan_webapp ==
            AppType.Book_Order_Online_App
          ) {
            if (resp.data.length > 0 && this.Merchant.bookit_fee_apply) {
              this.IsError = false;
              this.DeliveryFeeProduct = resp.data;
              var deliveryFeeAmount = this.DeliveryFeeProduct.reduce(
                (sum, item) => sum + item.price * 1,
                0
              );
              this.PopupHeader = "Booking Fees";
              this.Message =
                "Booking Fees of " +
                merchantCurrency +
                " " +
                deliveryFeeAmount +
                " will be added to your bill. your total will be " +
                merchantCurrency +
                " " +
                Number(
                  this.currentBasket.totalPayableAmount + deliveryFeeAmount
                ) +
                " - do you wish to continue?";
              this.modalService.open(this.DeliveryFeeInfo, {
                centered: true,
                scrollable: true,
                backdrop: "static",
              });
            } else if (
              resp.data.length == 0 &&
              this.Merchant.bookit_fee_apply
            ) {
              this.IsError = true;
              this.PopupHeader = "Booking Fees";
              this.Message =
                "Please select an address inside our booking area - check the Book It policy for further details (go to homepage and click about button)";
              this.fulfillmentModel.selectedaddress = undefined;
              this.modalService.open(this.DeliveryFeeInfo, {
                centered: true,
                scrollable: true,
                backdrop: "static",
              });
            } else {
              this.PlaceOrder(fulfillment);
            }
          } else if (
            this.Merchant.webapp_settings?.is_scan_webapp ==
            AppType.restaurant_App
          ) {
            if (resp.data.length > 0 && this.Merchant.serveit_fee_apply) {
              this.IsError = false;
              this.DeliveryFeeProduct = resp.data;
              var deliveryFeeAmount = this.DeliveryFeeProduct.reduce(
                (sum, item) => sum + item.price * 1,
                0
              );
              this.PopupHeader = "Delivery fees";
              this.Message =
                "Delivery fees of " +
                merchantCurrency +
                " " +
                Number(deliveryFeeAmount).toFixed() +
                " will be added to your bill. Your total will be " +
                merchantCurrency +
                " " +
                Number(
                  this.currentBasket.totalPayableAmount + deliveryFeeAmount
                ).toFixed(this.currentMerchant.currency_decimals ?? 2) +
                " - do you wish to continue?";
              this.modalService.open(this.DeliveryFeeInfo, {
                centered: true,
                scrollable: true,
                backdrop: "static",
              });
            } else if (resp.data.length == 0) {
              this.IsError = true;
              this.PopupHeader = "Delivery fees";
              this.Message =
                "Please select an address inside our delivery area - check the Deliver It policy for further details (go to homepage and click about button)";
              this.fulfillmentModel.selectedaddress = undefined;
              this.modalService.open(this.DeliveryFeeInfo, {
                centered: true,
                scrollable: true,
                backdrop: "static",
              });
            } else {
              this.PlaceOrder(fulfillment);
            }
          }
        },
        error: (error) => {},
        complete: () => console.info("Order placed"),
        // complete: () =>PlaceOrder(fulfillment);,
      });
    }
  }
  editAddress(address: any) {
    this.OpenAddress.emit(address);
  }

  deleteAddress(address: any) {
    console.log("Delete clicked for:", address);
    this.userService.DeleteAddress(address.id).subscribe((response) => {
      if (response) {
        this.Addresses = this.Addresses.filter((addr) => addr !== address);

        this.fulfillmentModel.selectedaddress = undefined;
        this.CheckForLocations();
      }
    });
    //this.Addresses = this.Addresses.filter(addr => addr !== address); // Remove the address from Addresses
    // Implement your delete logic here
  }

  CheckForLocations() {
    if (this.IsAddressVisible) {
      if (this.Addresses.length <= 0) {
        this.IsAddressNotAvailable = true;

        this.AddressValidationMessage =
          "You do not have any address for delivery, Click proceed to add a new address.";
        this.modalService.open(this.AddressValidationModal, {
          centered: true,
          scrollable: true,
          backdrop: "static",
        });
      }
    }
  }

  LocationChanged(selectedTable: any, isUserLocation: boolean) {
    if (this.Addresses == undefined || this.Addresses?.length === 0) {
      this.ngZone.run(() => {
        if (this.IsUserAuthunticated()) {
          this.userService.GetUserProfile().subscribe((response) => {
            this.Addresses = response.addresses;
            this.cds.detectChanges();
          });
        }
      });
    }

    if (this.isServe) {
      const foundTable = this.currentMerchant?.table?.find(
        (table: any) => table.id === selectedTable.id
      );

      if (foundTable) {
        if (foundTable.name == "CLCT") {
          this.IsAddressVisible = false;
          this.IsDeliveryFeeApply = false;
          this.fulfillmentModel.selectedaddress = this.currentMerchant?.address;
          this.fulfillmentModel.isDeliver = false;
        } else if (foundTable.name == "DLVR" || foundTable.name == "HDLVR") {
          if (!this.IsUserAuthunticated()) {
            if (!localStorage.getItem("skipped_login")) {
              this.openLogin.emit();
              this.fulfillmentModel.selectedTable = null;
              this.fulfillmentModel.selectedaddress = null;
            }
          }

          this.IsAddressVisible = true;
          this.IsDeliveryFeeApply = true;
          this.fulfillmentModel.isDeliver = true;

          if (!isUserLocation) {
            if (this.Addresses?.length == 1) {
              this.fulfillmentModel.selectedaddress = this.Addresses[0];
            } else {
              this.fulfillmentModel.selectedaddress = null;
            }
          }

          this.CheckForLocations();
        } else {
          this.IsAddressVisible = false;
          this.IsDeliveryFeeApply = true;
          this.fulfillmentModel.selectedaddress = this.currentMerchant?.address;
          this.fulfillmentModel.isDeliver = false;
        }
      }
    }
  }

  IsUserAuthunticated(): boolean {
    let currentUser: any = {};

    try {
      currentUser =
        JSON.parse(localStorage.getItem("currentUser") || "{}") || {};
    } catch {
      currentUser = {}; // fallback if JSON.parse fails
    }

    return (
      !!currentUser?.token && // must have a valid token
      !currentUser?.guest_access_allowed && // guest access should not be allowed
      this.coreService?.stcurrentUrl !== "/" // not on homepage
    );
  }

  closeCheckout() {
    this.closeProcessingFee();
  }

  closeDeliveryFee() {
    this.coreService.removeDeliveryFeeItemToBasket();
  }
  closeProcessingFee() {
    this.closeDeliveryFee();
  }
}
